<template>
  <div class="container mx-auto lg:min-h-screen relative">
    <div class="flex flex-col lg:flex-row flex-wrap mt-16">
      <div v-if="isLoading">
        <loading
          :active.sync="isLoading"
          :loader="'dots'"
          :can-cancel="false"
          :is-full-page="false">
        </loading>
      </div>
      <h2 :class="(dark) ? 'bg-medredDark' : 'bg-dpurpleLight'" class="text-white font-bold py-4 px-8 rounded-lg font-xl my-8 leading-relaxed w-full">{{ $t('stats.lastupdate') + lastupdate }}</h2>
      <div class="w-full lg:w-full" v-if="fetchCompleted">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.global') }}</h2>
          </div>
          <div id="corona-chart" class="widget-content h-300 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
            <highcharts class="chart rounded-b-lg" :options="chartOptions" :updateArgs="updateArgs" :callback="positionChart"></highcharts>
            <div id="corona-title" class="widget-content h-300 bg-white rounded-b-lg">
              <span id="co-title" class="text-xl" :style="(dark) ? 'color: white' : ''"><h3 style="font-size: 2rem">{{this.total}}</h3>{{ $t('stats.casconf') }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-3/5" v-if="'DISABLED' === null">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.map') }}</h2>
          </div>
          <div class="widget-content h-300 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
            <LMap class="rounded-b-lg" :zoom=4 :min-zoom=4 :max-zoom=6 :center="centerCords" style="width: 100%; height: 300px !important; overflow: hidden;">
              <LControl
                position="bottomright">
                <div class="info legend">
                  <i style="background: #FFCDCD"></i><span style="font-size: small;">0&ndash;{{parseInt(this.maxCases * 1 / 11)}}</span><br>
                  <i style="background: #FF9393"></i><span style="font-size: small;">{{parseInt(this.maxCases * 1 / 11)}}&ndash;{{parseInt(this.maxCases * 3 / 11)}}</span><br>
                  <i style="background: #FF7777"></i><span style="font-size: small;">{{parseInt(this.maxCases * 3 / 11)}}&ndash;{{parseInt(this.maxCases * 5 / 11)}}</span><br>
                  <i style="background: #FF5C5C"></i><span style="font-size: small;">{{parseInt(this.maxCases * 5 / 11)}}&ndash;{{parseInt(this.maxCases * 7 / 11)}}</span><br>
                  <i style="background: #FF4141"></i><span style="font-size: small;">{{parseInt(this.maxCases * 7 / 11)}}&ndash;{{parseInt(this.maxCases * 9 / 11)}}</span><br>
                  <i style="background: #FF0000"></i><span style="font-size: small;">+{{parseInt(this.maxCases * 9 / 11)}}</span><br>
                </div>
              </LControl>
              <LControl
                position="topright">
                <div class="info">
                  <h4>Coronavirus Cases</h4>
                  <b id="cName"></b>
                  <b id="cCount" style="font-size: 10px; font-weight: 100;"></b>
                </div>
              </LControl>
              <LMarkerCluster :options="clusterOptions">
                <LGeoJson
                  v-for="geoJson in geoJsons"
                  :key="geoJson.properties.region_id"
                  :geojson="geoJson"
                  :options="geoJsonOpt"
                  :optionsStyle="geoJsonOptions(geoJson.properties.count, geoJson.properties.region_id)"
                ></LGeoJson>
              </LMarkerCluster>
            </LMap>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-2/6" v-if="fetchCompleted">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.mregions') }}</h2>
          </div>
          <div v-if="$route.params.lang == 'ar'" style="direction: rtl" class="rounded-b-lg p-4" :class="(dark) ? 'bg-widgetbgDark' : 'bg-white'">
            <div class="cities flex content-center mb-2" v-for="(item, i) in orderBy(datatable,'confirmed').reverse()" :key="i">
              <div class="w-5/6 rounded-r-lg shadow px-4 py-2 ml-2 leading-none" :class="(dark) ? 'bg-sideDark text-white' : 'bg-widgetheaderLight'">{{ item.region_name_ar }}</div>
              <div class="w-1/6 text-white font-bold rounded-l-lg shadow px-4 py-2 flex items-center leading-none" :class="(dark) ? 'bg-medredDark' : 'bg-yellowLight'">{{item.confirmed}}</div>
            </div>
          </div>
          <div v-else style="direction: ltr" class="rounded-b-lg p-4" :class="(dark) ? 'bg-widgetbgDark' : 'bg-white'">
            <div class="cities flex content-center mb-2" v-for="(item, i) in orderBy(datatable,'confirmed').reverse()" :key="i">
              <div class="w-5/6 rounded-l-lg shadow px-4 py-2 ml-2 leading-none" :class="(dark) ? 'bg-sideDark text-white' : 'bg-widgetheaderLight'">{{ item.region_name_en }}</div>
              <div class="w-1/6 text-white font-bold rounded-r-lg shadow px-4 py-2 flex items-center leading-none" :class="(dark) ? 'bg-medredDark' : 'bg-yellowLight'">{{item.confirmed}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-4/6" v-if="fetchCompleted">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.sregions') }}</h2>
          </div>
          <div class="widget-content h-512 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
            <highcharts class="rounded-b-lg" :options="chartColumnsOptions" :updateArgs="updateArgs"></highcharts>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-6/6" v-if="'DISABLED' === null">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.countries') }}</h2>
          </div>
          <div class="widget-content h-512 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
            <highcharts class="rounded-b-lg" :options="chartLinesOptions" :updateArgs="updateArgs"></highcharts>
          </div>
        </div>
      </div>
      <!-- Start Testing Charts -->
      <div class="w-full lg:w-3/6" v-if="fetchCompleted">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.tests') }}</h2>
          </div>
          <div class="widget-content h-512 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
            <highcharts class="rounded-b-lg" :options="chartColumnsPieOptions" :updateArgs="updateArgs"></highcharts>
          </div>
        </div>
      </div>
      <div class="w-full lg:w-3/6" v-if="fetchCompleted">
        <div class="m-4 widget shad rounded-lg">
          <div class="widget_title p-4 rounded-t-lg" :class="(dark) ? 'bg-widgetheaderDark text-white' : 'bg-widgetheaderLight'">
            <h2 class="text-xl">{{ $t('stats.percentstats') }}</h2>
          </div>
          <div class="widget-content h-512 bg-white rounded-b-lg" :style="(dark) ? 'background: #00232a' : 'background: white'">
            <highcharts class="rounded-b-lg" :options="chartPercentOptions" :updateArgs="updateArgs"></highcharts>
          </div>
        </div>
      </div>
      <NewCharts v-if="'fetchCompleted' === null" />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import geoJsons from '../region.json'
import $ from 'jquery'
import 'vue-loading-overlay/dist/vue-loading.css'
import Loading from 'vue-loading-overlay';
import { LMap, LGeoJson, LControl } from 'vue2-leaflet'
import Vue2Filters from 'vue2-filters'
import LMarkerCluster from 'vue2-leaflet-markercluster'

import NewCharts from '../components/NewCharts.vue'

export default {
  name: "Stats",
  computed: {
    dark () {
      return this.$store.state.dark
    }
  },
  mixins: [Vue2Filters.mixin],
  data() {
    let geoJsonOpt = {
      onEachFeature: function (feature, layer) {
        var weight = layer.options.style.weight;
        layer.on("mouseover", function (e) {
          $('#cName').show().html(feature.properties.Name + '<br>');
          $('#cCount').show().html(feature.properties.count);
        });
        layer.on("mouseout", function (e) {
          $('#cName').show().html('');
          $('#cCount').show().html('');
        });
        layer.on('click', function(e) {
          $('#cName').show().html(feature.properties.Name + '<br>');
          $('#cCount').show().html(feature.properties.count);
        });
      }
    }
    function getColor(d) {
      return  d >= (global.maxCases * 9 / 11)  ?  '#FF0000' :
              d >= (global.maxCases * 7 / 11)  ?  '#FF4141' :
              d >= (global.maxCases * 5 / 11)  ?  '#FF5C5C' :
              d >= (global.maxCases * 3 / 11)  ?  '#FF7777' :
              d >= (global.maxCases * 1 / 11)  ?  '#FF9393' :
              d > 0                           ?  '#FFCDCD' :
                                                 '#FFFFFF';
    }
    function geoJsonOptions(count, id) {
      return {
        fillColor: getColor(count),
        weight: (id < 13) ? 2 : 1,
        opacity: 1,
        color: (id < 13) ? '#FFFFFF' : '#474747',
        dashArray: '3',
        fillOpacity: 0.7
      }
    }
    return {
      lastupdate: '',
      datatable: [],
      total: 0,
      maxCases: 0,
      centerCords: [26.7, 7.8545672],
      geoJsons,
      geoJsonOpt,
      geoJsonOptions,
      fetchCompleted: false,
      isLoading: true,
      clusterOptions: {},
      updateArgs: [true, true, {duration: 1000}],
      chartOptions: {
        chart: {
          backgroundColor: '#FFF',
          plotBorderWidth: null,
          plotShadow: false,
          height: 300,
          events: {
            render: function() {
              var textX = this.plotLeft + (this.series[0].center[0]);
              var textY = this.plotTop  + (this.series[0].center[1]);

              var span = $('#co-title');
              span.css('left', textX + (span.width() * -0.5));
              span.css('top', textY + (span.height() * -0.5));
            }
          },
          type: 'pie'
        },
        title: null,
        credits: {
          enabled: false
        },
        legend:{
          enabled:false
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            borderColor: null,
            dataLabels: {
              enabled: true,
              color: '#000000',
              formatter:function(){
                return (this.key + ' ' + this.y);
              }
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Stats',
          colorByPoint: true,
            innerSize: '70%',
          data: [{
            name: this.$t('charts.deaths'),
            color: '#422461',
            y: 0,
          }, {
            name: this.$t('charts.recoveries'),
            color: '#6c29a0',
            y: 0
          }, {
            name: this.$t('charts.sick'),
            color: '#ffb800',
            y: 0
          }]
        }]
      },
      chartBarsOptions: {
        chart: {
          backgroundColor: '#FFF',
          spacingLeft: 40,
          height: 512,
          type: 'bar'
        },
        title: null,
        xAxis: {
          categories: ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
          lineWidth: 0,
          gridLineWidth: 0,
          lineColor: 'transparent',
          minorTickLength: 0,
          labels : {
            format: '{value.name}    {value.count}',
            enabled: true,
            style:{
              fontSize: '13px',
              color: '#000000',
              fontWeight: 'bold'
            }
          },
          tickLength: 0,
          title: {
            enabled: false
          }
        },
        yAxis: {
          lineWidth: 0,
          gridLineWidth: 0,
          lineColor: 'transparent',
          labels: {
            enabled: false,
          },
          minorTickLength: 0,
          tickLength: 0,
          title: {
            enabled: false
          }
        },
        credits: {
          enabled: false
        },
        legend:{
          reversed: true,
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        plotOptions: {
          series: {
            stacking: 'normal',
            style: {
              color: '#fff000'
            },
            borderWidth: 0
          }
        },
        series: [{
          name: this.$t('charts.deaths'),
          color: '#422461',
          data: [3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3, 3]
        }, {
          name: this.$t('charts.sick'),
          color: '#ffb800',
          data: [1, 3, 5, 1, 2, 1, 3, 5, 1, 2, 3, 5]
        }, {
          name: this.$t('charts.recoveries'),
          color: '#6c29a0',
          data: [1, 3, 5, 2, 2, 1, 3, 5, 6, 2, 3, 5]
        }]
      },
      chartLinesOptions: {
        chart: {
          backgroundColor: '#FFF',
          height: 512,
          type: 'line'
        },
        title: null,
        xAxis: {
          categories: [],
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: this.$t('charts.casconf'),
            style:{
              color: '#000000'
            }
          }
        },
        legend:{
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        credits: {
          enabled: false
        },
        /*plotOptions: {
          line: {
            dataLabels: {
                enabled: false
            },
            enableMouseTracking: true
          }
        },*/
        tooltip: {
          formatter: function () {
            return (this.y);
          }
        },
        series: [{
          name: this.$t('countries.maroc'),
          data: []
        }, {
          name: this.$t('countries.tunisie'),
          data: []
        }, {
          name: this.$t('countries.libye'),
          data: []
        }, {
          name: this.$t('countries.mauritanie'),
          data: []
        }, {
          name: this.$t('countries.algerie'),
          data: []
        }, {
          name: this.$t('countries.egypte'),
          data: []
        }]
      },
      chartColumnsPieOptions: {
        chart: {
          backgroundColor: '#FFF',
          height: 512,
          type: 'column'
        },
        title: null,
        xAxis: {
          categories: [],
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          max: 300,
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: this.$t('charts.y_label'),
            style:{
              color: '#000000'
            }
          }
        },
        legend:{
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        tooltip: {
          formatter: function () {
            return (this.y);
          }
        },
        series: [{
          name: this.$t('charts.tests'),
          color: '#fff',
          data: []
        }, {
          name: this.$t('charts.confirmed'),
          color: '#fff',
          data: []
        }, {
          type: 'pie',
          name: 'Total',
          data: [{
              name: this.$t('charts.pie_confirmed'),
              color: '#fff',
              dataLabels: {
                enabled: true,
                color: '#FF0EFF',
                style: { 
                  textOutline: false,
                  fontSize: 14
                }
              },
              y: 0
            }, {
              name: this.$t('charts.pie_dismissed'),
              color: '#fff',
              dataLabels: {
                enabled: true,
                color: '#FF0EFF',
                style: {
                  textOutline: false,
                  fontSize: 14
                }
              },
              y: 0
            }],
            center: [140, 80],
            size: 120,
            showInLegend: false,
            borderColor: null,
        }]
      },
      chartColumnsOptions: {
        chart: {
          backgroundColor: '#FFF',
          height: 512,
          type: 'column'
        },
        title: null,
        xAxis: {
          categories: [],
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          max: 300,
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: this.$t('stats.y_label'),
            style:{
              color: '#000000'
            }
          }
        },
        legend:{
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        credits: {
          enabled: false
        },
        plotOptions: {
          column: {
            pointPadding: 0.2,
            borderWidth: 0
          }
        },
        tooltip: {
          formatter: function () {
            return (this.y);
          }
        },
        series: [{
          name: this.$t('charts.recoveries'),
          color: '#fff',
          data: []
        }, {
          name: this.$t('charts.deaths'),
          color: '#fff',
          data: []
        },]
      },
      chartPercentOptions: {
        chart: {
          backgroundColor: '#FFF',
          height: 512,
          type: 'spline'
        },
        title: null,
        xAxis: {
          categories: [],
          labels : {
            style:{
              color: '#000'
            }
          },
          title: {
            text: null
          }
        },
        yAxis: {
          max: 100,
          labels : {
            style:{
              color: '#000000'
            }
          },
          title: {
            text: this.$t('charts.casconf'),
            style:{
              color: '#000000'
            }
          }
        },
        legend:{
          itemHiddenStyle: {
            color: '#cccccc'
          },
          itemHoverStyle: {
            color: '#333333'
          },
          itemStyle: {
            color: '#000000',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: 'bold',
            textOverflow: 'ellipsis'
          }
        },
        credits: {
          enabled: false
        },
        tooltip: {
          enabled: false
        },
        plotOptions: {
          spline: {
            dataLabels: {
                enabled: true,
                formatter: function () {
                  return (this.y + '%');
                },
                color: '#ffb800',
                style: {
                  textOutline: '2px #6c29a0'
                }
            },
            lineWidth: 2,
            color: '#6c29a0'
          }
        },
        series: [{
          name: this.$t('charts.percent'),
          data: [],
          marker: {
            lineWidth: 2,
            lineColor: '#ffb800',
            fillColor: '#6c29a0'
          }
        }]
      }
    }
  },
  components: {
    LMap,
    LGeoJson,
    LControl,
    LMarkerCluster,
    NewCharts,
    Loading
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener('resize', this.getWindowWidth);
      this.getWindowWidth()
    })
  },
  methods: {
    getWindowWidth(event) {
      if (document.documentElement.clientWidth < 1024) {
        this.chartBarsOptions.chart.type = 'column';
        this.chartBarsOptions.xAxis.labels.style.fontSize = '6px';
        this.centerCords = [29, -10];
      }
      else {
        this.chartBarsOptions.chart.type = 'bar'
        this.chartBarsOptions.xAxis.labels.style.fontSize = '13px';
        this.centerCords = [26.7, 7.8545672];
      }
    },
    positionChart(chart) {
      this.chart = chart;
      var textX = chart.plotLeft + (chart.series[0].center[0]);
      var textY = chart.plotTop  + (chart.series[0].center[1]);

      var span = $('#co-title');
      span.css('left', textX + (span.width() * -0.5));
      span.css('top', textY + (span.height() * -0.5));
    },
    getDates(startDate) {
      var endDate = new Date();
      endDate.setDate(endDate.getDate() - 1);
      var dates = [];
      var addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      while (startDate <= endDate) {
        dates.push(startDate);
        startDate = addDays.call(startDate, 1);
      }
      return dates;
    },
    async initMap() {
      let index = 0;

      return await axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/data_by_regions.json' })
      .then(resp => {
        this.lastupdate = resp.data['last_updated']
        this.datatable = resp.data.data.regions;
        global.maxCases = 0;
        const data = resp.data.data.regions.sort((a, b) => parseInt(b.region_code.split("MA")[1]) - parseInt(a.region_code.split("MA")[1])).reverse();
        this.geoJsons = this.geoJsons.sort((a, b) => b.properties.region_id - a.properties.region_id).reverse();
        this.total = resp.data.data.country[0].confirmed;
        this.chartOptions.series[0].data[0].y = resp.data.data.country[0].deaths;
        this.chartOptions.series[0].data[1].y = resp.data.data.country[0].recovered;
        this.chartOptions.series[0].data[2].y = this.total - resp.data.data.country[0].deaths - resp.data.data.country[0].recovered;
        data.forEach(element => {
          if (element.confirmed > global.maxCases) {
            global.maxCases = element.confirmed;
          }
          this.geoJsons[index].properties.count = element.confirmed;
          this.chartBarsOptions.xAxis.categories[index] = { name: (this.$route.params.lang == 'ar') ? element.region_name_ar : element.region_name_en, count: element.confirmed };
          this.chartBarsOptions.series[0].data[index] = element.deaths;
          this.chartBarsOptions.series[1].data[index] = element.confirmed - element.deaths - element.recovered;
          this.chartBarsOptions.series[2].data[index] = element.recovered;
          index++;
        })
        this.maxCases = global.maxCases;
      })
      .catch(err => {
        console.error(err)
      })
      this.fetchCompleted = true;
    },
    async initMap2() {
      return await axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/data_by_country.json' })
      .then(resp => {
        resp.data.data.countries.forEach(element => {
          this.geoJsons.some(ele => {
            if (ele.properties['Name'] == element.country_name_en) {
              ele.properties.count = element.confirmed;
              return ;
            }
          })
        })
      }).catch(err => {
        console.error(err)
      })
    },
    getCountries() {
      const currentDate = new Date();
      currentDate.setMonth(currentDate.getMonth() - 1);
      const dateRange = this.getDates(currentDate);
      axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/csse_covid_19_data/csse_covid_19_time_series/time_series_covid19_confirmed_global.json' })
      .then(resp => {
        dateRange.forEach(date => {
          var format = (new Date(date.valueOf())).toISOString();
          format = parseInt(format.substring(5, 7)) + '/' + parseInt(format.substring(8, 10)) + '/' + format.substring(2, 4);
          this.chartLinesOptions.xAxis.categories.push(format);
          resp.data.forEach(ele => {
            if (ele['Country/Region'] == 'Morocco') {
              this.chartLinesOptions.series[0].data.push(parseFloat(ele[format]));
            }
            if (ele['Country/Region'] == 'Tunisia') {
              this.chartLinesOptions.series[1].data.push(parseFloat(ele[format]));
            }
            if (ele['Country/Region'] == 'Libya') {
              this.chartLinesOptions.series[2].data.push(parseFloat(ele[format]));
            }
            if (ele['Country/Region'] == 'Mauritania') {
              this.chartLinesOptions.series[3].data.push(parseFloat(ele[format]));
            }
            if (ele['Country/Region'] == 'Algeria') {
              this.chartLinesOptions.series[4].data.push(parseFloat(ele[format]));
            }
            if (ele['Country/Region'] == 'Egypt') {
              this.chartLinesOptions.series[5].data.push(parseFloat(ele[format]));
            }
          })
        })
      })
      .catch(err => {
        console.error(err)
      })
    },
    getNewStats() {
      axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/data_by_day.json' })
      .then(resp => {
        const data = resp.data.data;
        var maxValue = 0;
        this.chartColumnsPieOptions.series[2].data[0].y = data['Total'][0].confirmed;
        this.chartColumnsPieOptions.series[2].data[1].y = data['Total'][0].excluded;
        data['Tested'].forEach(element => {
          if (element.total > maxValue) {
            maxValue = element.total;
          }
          this.chartPercentOptions.xAxis.categories.push(element.date)
          this.chartColumnsPieOptions.xAxis.categories.push(element.date)
          this.chartColumnsPieOptions.series[0].data.push(element.total);
          this.chartColumnsPieOptions.series[1].data.push(element.confirmed);
          var percent = (element.total) ? (element.confirmed * 100 / element.total) : 0;
          this.chartPercentOptions.series[0].data.push(parseInt(percent.toFixed(2)))
        })
        this.chartColumnsPieOptions.yAxis.max = maxValue + 1000;
      }).catch(err => {
        console.error(err)
      })
    },
    getDeathStats() {
      axios({ method: 'GET', url: 'https://raw.githubusercontent.com/afaddoul/covid19-maroc-data/master/data_per_day.json' })
      .then(resp => {
        const data = resp.data.data;
        var maxValue = 0;
        data.forEach(element => {
          if (Math.max(element.deaths, element.recovered) > maxValue) {
            maxValue = Math.max(element.deaths, element.recovered);
          }
          this.chartColumnsOptions.xAxis.categories.push(element.pub_date)
          this.chartColumnsOptions.series[0].data.push(element.recovered);
          this.chartColumnsOptions.series[1].data.push(element.deaths);
        })
        this.chartColumnsOptions.yAxis.max = maxValue + 500;
      }).catch(err => {
        console.error(err)
      })
    },
    initColors() {
      if (this.dark == true) {
        this.chartOptions.chart.backgroundColor = '#00232a';
        this.chartOptions.plotOptions.pie.dataLabels.color = '#ffffff'
        this.chartOptions.series[0].data[0].color = '#66153e';
        this.chartOptions.series[0].data[1].color = '#ff005c';
        this.chartOptions.series[0].data[2].color = '#b20a4d';
        this.chartBarsOptions.chart.backgroundColor = '#00232a';
        this.chartBarsOptions.xAxis.labels.style.color = '#ffffff';
        this.chartBarsOptions.legend.itemStyle.color = '#ffffff';
        this.chartBarsOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartBarsOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartBarsOptions.series[0].color = '#66153e';
        this.chartBarsOptions.series[1].color = '#b20a4d';
        this.chartBarsOptions.series[2].color = '#ff005c';
        this.chartLinesOptions.chart.backgroundColor = '#00232a';
        this.chartLinesOptions.xAxis.labels.style.color = '#ffffff';
        this.chartLinesOptions.yAxis.labels.style.color = '#ffffff';
        this.chartLinesOptions.yAxis.title.style.color = '#ffffff';
        this.chartLinesOptions.legend.itemStyle.color = '#ffffff';
        this.chartLinesOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartLinesOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartColumnsPieOptions.chart.backgroundColor = '#00232a';
        this.chartColumnsPieOptions.xAxis.labels.style.color = '#ffffff';
        this.chartColumnsPieOptions.yAxis.labels.style.color = '#ffffff';
        this.chartColumnsPieOptions.yAxis.title.style.color = '#ffffff';
        this.chartColumnsPieOptions.legend.itemStyle.color = '#ffffff';
        this.chartColumnsPieOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartColumnsPieOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartColumnsPieOptions.series[2].data[1].color = '#b20a4d';
        this.chartColumnsPieOptions.series[2].data[0].color = '#ff005c';
        this.chartColumnsPieOptions.series[0].color = '#b20a4d';
        this.chartColumnsPieOptions.series[1].color = '#ff005c';
        this.chartColumnsPieOptions.series[2].data[1].dataLabels.color = '#b20a4d';
        this.chartColumnsPieOptions.series[2].data[0].dataLabels.color = '#ff005c';
        this.chartPercentOptions.chart.backgroundColor = '#00232a';
        this.chartPercentOptions.xAxis.labels.style.color = '#ffffff';
        this.chartPercentOptions.yAxis.labels.style.color = '#ffffff';
        this.chartPercentOptions.yAxis.title.style.color = '#ffffff';
        this.chartPercentOptions.legend.itemStyle.color = '#ffffff';
        this.chartPercentOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartPercentOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartPercentOptions.series[0].marker.fillColor = '#b20a4d';
        this.chartPercentOptions.series[0].marker.lineColor = '#ff005c';
        this.chartPercentOptions.plotOptions.spline.color = '#b20a4d';
        this.chartPercentOptions.plotOptions.spline.dataLabels.color = '#fff';
        this.chartPercentOptions.plotOptions.spline.dataLabels.style.textOutline = '0px #fff';
        this.chartColumnsOptions.chart.backgroundColor = '#00232a';
        this.chartColumnsOptions.xAxis.labels.style.color = '#ffffff';
        this.chartColumnsOptions.yAxis.labels.style.color = '#ffffff';
        this.chartColumnsOptions.yAxis.title.style.color = '#ffffff';
        this.chartColumnsOptions.legend.itemStyle.color = '#ffffff';
        this.chartColumnsOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartColumnsOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartColumnsOptions.series[0].color = '#b20a4d';
        this.chartColumnsOptions.series[1].color = '#ff005c';
      }
      else {
        this.chartOptions.chart.backgroundColor = '#ffffff';
        this.chartOptions.plotOptions.pie.dataLabels.color = '#000000'
        this.chartOptions.series[0].data[0].color = '#422461';
        this.chartOptions.series[0].data[1].color = '#6c29a0';
        this.chartOptions.series[0].data[2].color = '#ffb800';
        this.chartBarsOptions.chart.backgroundColor = '#ffffff';
        this.chartBarsOptions.xAxis.labels.style.color = '#000000';
        this.chartBarsOptions.legend.itemStyle.color = '#000000';
        this.chartBarsOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartBarsOptions.legend.itemHoverStyle.color = '#333333';
        this.chartBarsOptions.series[0].color = '#422461';
        this.chartBarsOptions.series[1].color = '#ffb800';
        this.chartBarsOptions.series[2].color = '#6c29a0';
        this.chartLinesOptions.chart.backgroundColor = '#ffffff';
        this.chartLinesOptions.xAxis.labels.style.color = '#000000';
        this.chartLinesOptions.yAxis.labels.style.color = '#000000';
        this.chartLinesOptions.yAxis.title.style.color = '#000000';
        this.chartLinesOptions.legend.itemStyle.color = '#000000';
        this.chartLinesOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartLinesOptions.legend.itemHoverStyle.color = '#333333';
        this.chartColumnsPieOptions.chart.backgroundColor = '#ffffff';
        this.chartColumnsPieOptions.xAxis.labels.style.color = '#000000';
        this.chartColumnsPieOptions.yAxis.labels.style.color = '#000000';
        this.chartColumnsPieOptions.yAxis.title.style.color = '#000000';
        this.chartColumnsPieOptions.legend.itemStyle.color = '#000000';
        this.chartColumnsPieOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartColumnsPieOptions.legend.itemHoverStyle.color = '#333333';
        this.chartColumnsPieOptions.series[2].data[1].color = '#6c29a0';
        this.chartColumnsPieOptions.series[2].data[0].color = '#ffb800';
        this.chartColumnsPieOptions.series[0].color = '#6c29a0';
        this.chartColumnsPieOptions.series[1].color = '#ffb800';
        this.chartColumnsPieOptions.series[2].data[1].dataLabels.color = '#6c29a0';
        this.chartColumnsPieOptions.series[2].data[0].dataLabels.color = '#ffb800';
        this.chartPercentOptions.chart.backgroundColor = '#ffffff';
        this.chartPercentOptions.xAxis.labels.style.color = '#000000';
        this.chartPercentOptions.yAxis.labels.style.color = '#000000';
        this.chartPercentOptions.yAxis.title.style.color = '#000000';
        this.chartPercentOptions.legend.itemStyle.color = '#000000';
        this.chartPercentOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartPercentOptions.legend.itemHoverStyle.color = '#333333';
        this.chartPercentOptions.series[0].marker.fillColor = '#6c29a0';
        this.chartPercentOptions.series[0].marker.lineColor = '#ffb800';
        this.chartPercentOptions.plotOptions.spline.color = '#6c29a0';
        this.chartPercentOptions.plotOptions.spline.dataLabels.color = '#ffb800';
        this.chartPercentOptions.plotOptions.spline.dataLabels.style.textOutline = '2px #6c29a0';
        this.chartColumnsOptions.xAxis.labels.style.color = '#000000';
        this.chartColumnsOptions.yAxis.labels.style.color = '#000000';
        this.chartColumnsOptions.yAxis.title.style.color = '#000000';
        this.chartColumnsOptions.legend.itemStyle.color = '#000000';
        this.chartColumnsOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartColumnsOptions.legend.itemHoverStyle.color = '#333333';
        this.chartColumnsOptions.series[0].color = '#6c29a0';
        this.chartColumnsOptions.series[1].color = '#ffb800';
      }
    }
  },
  watch: {
    dark: function(newVal, oldVal) {
      if (newVal == true) {
        this.chartOptions.chart.backgroundColor = '#00232a';
        this.chartOptions.plotOptions.pie.dataLabels.color = '#ffffff'
        this.chartOptions.series[0].data[0].color = '#66153e';
        this.chartOptions.series[0].data[1].color = '#ff005c';
        this.chartOptions.series[0].data[2].color = '#b20a4d';
        this.chartBarsOptions.chart.backgroundColor = '#00232a';
        this.chartBarsOptions.xAxis.labels.style.color = '#ffffff';
        this.chartBarsOptions.legend.itemStyle.color = '#ffffff';
        this.chartBarsOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartBarsOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartBarsOptions.series[0].color = '#66153e';
        this.chartBarsOptions.series[1].color = '#b20a4d';
        this.chartBarsOptions.series[2].color = '#ff005c';
        this.chartLinesOptions.chart.backgroundColor = '#00232a';
        this.chartLinesOptions.yAxis.title.style.color = '#ffffff';
        this.chartLinesOptions.xAxis.labels.style.color = '#ffffff';
        this.chartLinesOptions.yAxis.labels.style.color = '#ffffff';
        this.chartLinesOptions.legend.itemStyle.color = '#ffffff';
        this.chartLinesOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartLinesOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartColumnsPieOptions.chart.backgroundColor = '#00232a';
        this.chartColumnsPieOptions.xAxis.labels.style.color = '#ffffff';
        this.chartColumnsPieOptions.yAxis.labels.style.color = '#ffffff';
        this.chartColumnsPieOptions.yAxis.title.style.color = '#ffffff';
        this.chartColumnsPieOptions.legend.itemStyle.color = '#ffffff';
        this.chartColumnsPieOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartColumnsPieOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartColumnsPieOptions.series[0].color = '#b20a4d';
        this.chartColumnsPieOptions.series[1].color = '#ff005c';
        this.chartColumnsPieOptions.series[2].data[1].color = '#b20a4d';
        this.chartColumnsPieOptions.series[2].data[0].color = '#ff005c';
        this.chartColumnsPieOptions.series[2].data[1].dataLabels.color = '#b20a4d';
        this.chartColumnsPieOptions.series[2].data[0].dataLabels.color = '#ff005c';
        this.chartPercentOptions.chart.backgroundColor = '#00232a';
        this.chartPercentOptions.xAxis.labels.style.color = '#ffffff';
        this.chartPercentOptions.yAxis.labels.style.color = '#ffffff';
        this.chartPercentOptions.yAxis.title.style.color = '#ffffff';
        this.chartPercentOptions.legend.itemStyle.color = '#ffffff';
        this.chartPercentOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartPercentOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartPercentOptions.series[0].marker.fillColor = '#b20a4d';
        this.chartPercentOptions.series[0].marker.lineColor = '#ff005c';
        this.chartPercentOptions.plotOptions.spline.color = '#b20a4d';
        this.chartPercentOptions.plotOptions.spline.dataLabels.color = '#fff';
        this.chartPercentOptions.plotOptions.spline.dataLabels.style.textOutline = '0px #fff';
        this.chartColumnsOptions.chart.backgroundColor = '#00232a';
        this.chartColumnsOptions.xAxis.labels.style.color = '#ffffff';
        this.chartColumnsOptions.yAxis.labels.style.color = '#ffffff';
        this.chartColumnsOptions.yAxis.title.style.color = '#ffffff';
        this.chartColumnsOptions.legend.itemStyle.color = '#ffffff';
        this.chartColumnsOptions.legend.itemHiddenStyle.color = '#000000';
        this.chartColumnsOptions.legend.itemHoverStyle.color = '#dddddd';
        this.chartColumnsOptions.series[0].color = '#b20a4d';
        this.chartColumnsOptions.series[1].color = '#ff005c';

      }
      else {
        this.chartOptions.chart.backgroundColor = '#ffffff';
        this.chartOptions.plotOptions.pie.dataLabels.color = '#000000'
        this.chartOptions.series[0].data[0].color = '#422461';
        this.chartOptions.series[0].data[1].color = '#6c29a0';
        this.chartOptions.series[0].data[2].color = '#ffb800';
        this.chartBarsOptions.chart.backgroundColor = '#ffffff';
        this.chartBarsOptions.xAxis.labels.style.color = '#000000';
        this.chartBarsOptions.legend.itemStyle.color = '#000000';
        this.chartBarsOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartBarsOptions.legend.itemHoverStyle.color = '#333333';
        this.chartBarsOptions.series[0].color = '#422461';
        this.chartBarsOptions.series[1].color = '#ffb800';
        this.chartBarsOptions.series[2].color = '#6c29a0';
        this.chartLinesOptions.chart.backgroundColor = '#ffffff';
        this.chartLinesOptions.yAxis.title.style.color = '#000000';
        this.chartLinesOptions.xAxis.labels.style.color = '#000000';
        this.chartLinesOptions.yAxis.labels.style.color = '#000000';
        this.chartLinesOptions.legend.itemStyle.color = '#000000';
        this.chartLinesOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartLinesOptions.legend.itemHoverStyle.color = '#333333';
        this.chartColumnsPieOptions.chart.backgroundColor = '#ffffff';
        this.chartColumnsPieOptions.xAxis.labels.style.color = '#000000';
        this.chartColumnsPieOptions.yAxis.labels.style.color = '#000000';
        this.chartColumnsPieOptions.yAxis.title.style.color = '#000000';
        this.chartColumnsPieOptions.legend.itemStyle.color = '#000000';
        this.chartColumnsPieOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartColumnsPieOptions.legend.itemHoverStyle.color = '#333333';
        this.chartColumnsPieOptions.series[2].data[1].color = '#6c29a0';
        this.chartColumnsPieOptions.series[2].data[0].color = '#ffb800';
        this.chartColumnsPieOptions.series[0].color = '#6c29a0';
        this.chartColumnsPieOptions.series[1].color = '#ffb800';
        this.chartColumnsPieOptions.series[2].data[1].dataLabels.color = '#6c29a0';
        this.chartColumnsPieOptions.series[2].data[0].dataLabels.color = '#ffb800';
        this.chartPercentOptions.chart.backgroundColor = '#ffffff';
        this.chartPercentOptions.xAxis.labels.style.color = '#000000';
        this.chartPercentOptions.yAxis.labels.style.color = '#000000';
        this.chartPercentOptions.yAxis.title.style.color = '#000000';
        this.chartPercentOptions.legend.itemStyle.color = '#000000';
        this.chartPercentOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartPercentOptions.legend.itemHoverStyle.color = '#333333';
        this.chartPercentOptions.series[0].marker.fillColor = '#6c29a0';
        this.chartPercentOptions.series[0].marker.lineColor = '#ffb800';
        this.chartPercentOptions.plotOptions.spline.color = '#6c29a0';
        this.chartPercentOptions.plotOptions.spline.dataLabels.color = '#ffb800';
        this.chartPercentOptions.plotOptions.spline.dataLabels.style.textOutline = '2px #6c29a0';
        this.chartColumnsOptions.chart.backgroundColor = '#ffffff';
        this.chartColumnsOptions.xAxis.labels.style.color = '#000000';
        this.chartColumnsOptions.yAxis.labels.style.color = '#000000';
        this.chartColumnsOptions.yAxis.title.style.color = '#000000';
        this.chartColumnsOptions.legend.itemStyle.color = '#000000';
        this.chartColumnsOptions.legend.itemHiddenStyle.color = '#dddddd';
        this.chartColumnsOptions.legend.itemHoverStyle.color = '#333333';
        this.chartColumnsOptions.series[0].color = '#6c29a0';
        this.chartColumnsOptions.series[1].color = '#ffb800';   
      }
    }
  },
  async created() {
    this.initColors();
    // this.getCountries();
    this.getNewStats();
    this.getDeathStats();
    await this.initMap();
    // await this.initMap2();
    this.fetchCompleted = true;
    this.isLoading = false;
  }
}
</script>

<style scoped>
  @import "~leaflet/dist/leaflet.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.css";
  @import "~leaflet.markercluster/dist/MarkerCluster.Default.css";

  #corona-chart {
    height: 300px !important;
  }

  #corona-title {
    position: relative;
    height: 300px !important;
    transform: translate(0, -100%);
    background: transparent;
    pointer-events: none;
  }

  #co-title {
    position: absolute;
    text-align: center;
    font-family: 'Tajawal' !important;
    font-weight: bold;
    font-size: 15px;
  }

  .toolTip {
    text-align: center;
    font-family: 'Tajawal' !important;
  }
  @media (max-width: 1280px) {
    #co-title {
      left: 48%;
    }
  }
  @media (max-width: 1024px) {
    #co-title {
      left: 45%;
    }
  }
  @media (max-width: 440px) {
    #co-title {
      left: 46%;
    }
  }
  tspan {
    font-size: 1.25rem !important;
    font-family: 'Tajawal';
  }

  .info {
    padding: 6px 8px !important;
    font: 14px/16px Arial, Helvetica, sans-serif !important;
    background: white !important;
    background: rgba(255,255,255,0.8) !important;
    box-shadow: 0 0 15px rgba(0,0,0,0.2) !important;
    border-radius: 5px !important;
  }
  .info h4 {
    margin: 0 0 5px !important;
    color: #777 !important;
    font-weight: bold !important;
  }

  .legend {
    line-height: 18px !important;
    color: #555 !important;
  }
  .legend i {
    width: 18px !important;
    height: 18px !important;
    float: left !important;
    margin-right: 8px !important;
    opacity: 0.7 !important;
  }
</style>
